module.exports = __webpack_public_path__ + "static/media/DZ.a87c48e2.png";